$('form.complete-form .submit-form').click(function (e) {
    let form = $(this).closest('form');
    let formId = form[0].id;

    // MSD-718: the native `required` constraint would be bypassed by the
    // confirmation modal's programmatic form.submit(). Keep the all-No
    // acknowledgement visible and mandatory before opening that modal.
    let allNoConfirmation = form.find('input[name="confirm_all_no"]');
    if (allNoConfirmation.length && !allNoConfirmation.is(':checked')) {
        alert('Please confirm that every No answer is intentional before continuing.');
        return false;
    }

    let completeAssessmentModal = $('#complete-assessment-modal');
    let isLegacyCompletion = form.attr('data-completion-flow') === 'legacy';

    completeAssessmentModal.find('#complete-assessment-modal-title').text(
        isLegacyCompletion ? 'Finalize' : 'Calculate Risk'
    );
    completeAssessmentModal.find('#complete-assessment-modal-copy').text(
        isLegacyCompletion
            ? 'This finalizes the SRA and generates its Worklist.'
            : 'This scores your risk from the answers you have given and builds your Worklist. You can then review and adjust risk on the threat table before you Finalize the SRA.'
    );
    completeAssessmentModal.find('#submit-modal').text(
        isLegacyCompletion ? 'Finalize' : 'Calculate Risk'
    );
    showFollowupAdvisory(completeAssessmentModal, form);

    completeAssessmentModal.attr('data-assessment-id', formId);
    completeAssessmentModal.modal('show');
    return false;
});

$('form.lock-form .submit-form').click(function (e) {
    let form = $(this).closest('form');
    let formId = form[0].id;

    let lockAssessmentModal = $('#lock-assessment-modal');
    showFollowupAdvisory(lockAssessmentModal, form);

    lockAssessmentModal.attr('data-assessment-id', formId);
    lockAssessmentModal.modal('show');
    return false;
});

// Advisory only: the user may still calculate/finalize with flags outstanding.
function showFollowupAdvisory(modal, form) {
    modal.find('.mc-followup-advisory').remove();
    const count = Number(form.attr('data-followup-count') || 0);
    if (count > 0) {
        $('<p class="mc-followup-advisory mt-3 mb-0 text-warning" role="status"></p>')
            .text(count + ' walkthrough question(s) are still flagged for follow-up. You may continue, or cancel to review them.')
            .appendTo(modal.find('.modal-body'));
    }
}

$('#complete-assessment-modal #submit-modal').click(function () {
    let formId = $(this).closest('#complete-assessment-modal').data('assessment-id');
    let form = document.getElementById(formId);
    form.submit();
});

$('#lock-assessment-modal #submit-modal').click(function () {
    let formId = $(this).closest('#lock-assessment-modal').data('assessment-id');
    let form = document.getElementById(formId);
    form.submit();
});
$('form.reopen-form .submit-form').click(function (e) {
    let form = $(this).closest('form');
    let formId = form[0].id;

    let reopenAssessmentModal = $('#reopen-assessment-modal');

    reopenAssessmentModal.attr('data-assessment-id', formId);
    reopenAssessmentModal.modal('show');
    return false;
});

$('#reopen-assessment-modal #submit-modal').click(function () {
    let formId = $(this).closest('#reopen-assessment-modal').data('assessment-id');
    let form = document.getElementById(formId);
    form.submit();
});

// Worklist generation

$('a.print-worklist').click(function(event) {
    event.preventDefault();
    let printWorklistModal = $('#print-worklist-modal');
    printWorklistModal.attr('data-url',  $(this).data('href'));
    printWorklistModal.modal('show');
});
$('a.print-medman-worklist').click(function(event) {
    event.preventDefault();
    let printWorklistModal = $('#print-medman-worklist-modal');
    printWorklistModal.attr('data-url',  $(this).data('href'));
    printWorklistModal.modal('show');
});
$('a.print-assessment').click(function(event) {
    event.preventDefault();
    let printAssessmentModal = $('#print-assessment-modal');
    printAssessmentModal.attr('data-url',  $(this).data('href'));
    printAssessmentModal.modal('show');
});

// Name Edit generation

$('a.name_edit_btn').click(function(event) {
    event.preventDefault();
    let editNameModal = $('#edit-name-modal');
    editNameModal.attr('data-url',  $(this).data('href'));
    editNameModal.find('#edit-name-input').val($(this).data('name'));
    editNameModal.find('#edit-name-form').attr('action',$(this).data('href'));
    editNameModal.modal('show');
});

$('#edit-name-modal #submit-modal').click(function () {
    let form = document.getElementById("edit-name-form");
    form.submit();
});

// NVA Name Edit generation

$('a.nva_name_edit_btn').click(function(event) {
    event.preventDefault();
    let editNameModal = $('#nva_edit-name-modal');
    editNameModal.attr('data-url',  $(this).data('href'));
    editNameModal.find('#nva_edit-name-input').val($(this).data('name'));
    editNameModal.find('#nva_edit-name-form').attr('action',$(this).data('href'));
    editNameModal.modal('show');
});

$('#nva_edit-name-modal #submit-modal').click(function () {
    let form = document.getElementById("nva_edit-name-form");
    form.submit();
});

$('a.print-assessment').click(function(event) {
    event.preventDefault();
    let printAssessmentModal = $('#print-assessment-modal');
    printAssessmentModal.attr('data-url',  $(this).data('href'));
    printAssessmentModal.modal('show');
});

$('a.baa-disclaimer').click(function(event) {
    event.preventDefault();
    let baaDisclaimerModal = $('#baa-disclaimer-modal');
    baaDisclaimerModal.modal('show');
});

$('a.upload-baa-renew-btn').click(function(event) {
    event.preventDefault();
    let baaRenewModal = $('#baa-renewal-modal');
    $('#renewal-modal-renew').attr('action',  $(this).data('renew-url'));
    $('#renewal-modal-create').attr('href',  $(this).data('create-url'));

    baaRenewModal.modal('show');
});


$('a.baa-attestation-btn').click(function() {
    event.preventDefault();
    let attestationModal = $('#attestation-modal');
    attestationModal.attr('data-url', event.target.href);
    attestationModal.find('form').attr('action', event.target.href);
    attestationModal.modal('show');
});
$('a.approve-policy-btn').click(function(event) {
    event.preventDefault();
    const approveUrl = event.currentTarget.href;
    let approvePolicyModal = $('#approve-policy-modal');
    approvePolicyModal.attr('data-url', approveUrl);
    approvePolicyModal.find('form').attr('action', approveUrl);
    approvePolicyModal.modal('show');
});


$('section .see-more').click(function(event) {
    event.preventDefault();
    $(this).closest('section').toggleClass('collapsed');
});

// $('#print-worklist-modal #submit-modal').click(function () {
//     let url = $(this).closest('#print-worklist-modal').data('url');
//     window.open(url, '_blank');
//     $(this).closest('#print-worklist-modal').modal('hide');
// });

$('#attestation-modal #submit-modal').click(function () {
    $('#attestation-modal form').submit();
});

$('#approve-policy-modal #submit-modal').click(function () {
    $('#approve-policy-modal form').submit();
    $(this).closest('#print-worklist-modal').modal('hide');
});

$('.show-archived-policies').click(function () {
    $.ajax({
        type: 'GET',
        url: '/toggle-policy-archives',
        processData: false,
        contentType: 'application/json',
        success : function(response, textStatus, jqXhr) {
            $('.dashboard-container').toggleClass('show-policy-archives');
        },
    });
});

$('#affiliate_filter').click(function () {
    $('#filterform').attr('action', $('#affiliate_filter').attr('data-url')).submit();
});



$('.policy-archive-toggle').change(function(event) {
    let self = this;
    let checked = 0;

    let token = $('meta[name="csrf-token"]').val();
    let policy = $(this).data('policy');
    let url = $(this).data('url');
    if ($(this).is(':checked')) {
        checked = 1;
        if (!$(this).data('archive-confirmed') && $('#archive-policy-modal').length) {
            $(this).prop('checked', false);
            $('#archive-policy-name').text($(this).data('policy-name') || 'this policy');
            $('#archive-policy-modal').data('archive-toggle', this).modal('show');
            return;
        }
        $(this).removeData('archive-confirmed');
    } else {
        // Restore has its own confirmation and renews the retained policy.
        // Keep the toggle archived until the confirmed POST succeeds.
        $(this).prop('checked', true);
        window.location.assign(url + '/0');
        return;
    }


    $.ajax({
        type: 'GET',
        url: url + '/' + checked,
        processData: false,
        contentType: 'application/json',
        success : function(response, textStatus, jqXhr) {
            $(self).closest('.card').toggleClass('policy-archived');
        },
        error : function(jqXHR, textStatus, errorThrown) {
            if(checked){
                $(self).prop("checked", false);
            }else{
                $(self).prop("checked", true);
            }
        },
    });

});

$('#archive-policy-confirm').click(function () {
    let modal = $('#archive-policy-modal');
    let toggle = modal.data('archive-toggle');
    if (!toggle) return;
    modal.removeData('archive-toggle').modal('hide');
    $(toggle).data('archive-confirmed', true).prop('checked', true).trigger('change');
});

$('#archive-policy-modal').on('hidden.bs.modal', function () {
    $(this).removeData('archive-toggle');
});

$('.sra-archive-toggle').change(function(event) {
    // BUGFIX 2026-06-30: this used to only tick the checkbox and never
    // submit anything, so the SRA "Archive" toggle did nothing and the
    // assessment reverted to not-archived on reload. Submit the toggle's
    // PATCH form (route company_assessments.archive). Guard on the form's
    // dataset so it can't double-submit if another handler also fires.
    var form = $(this).closest('form.archive-sra-form').get(0);
    if (!form || form.dataset.mcSubmitting === '1') return;
    form.dataset.mcSubmitting = '1';
    form.submit();
});

$('.disable-privacy-toggle').change(function(event) {
    let self = this;
    let checked = 1;

    let token = $('meta[name="csrf-token"]').attr('content');
    let url = $(this).data('url');
    if ($(this).is(':checked')) {
        checked = 0;
    }


    if(checked){
        $(self).prop("checked", false);
    }else{
        $(self).prop("checked", true);
    }
    $.ajax({
        type: 'PATCH',
        url: url,
        data: JSON.stringify({active: checked}),
        processData: false,
        contentType: 'application/json',
        headers: {
            'X-CSRF-TOKEN': token,
        },
        success : function(response, textStatus, jqXhr) {
            location.reload();
        },
        error : function(jqXHR, textStatus, errorThrown) {
            if(checked){
                $(self).prop("checked", true);
            }else{
                $(self).prop("checked", false);
            }
        },
    });

});

$('#print-worklist-modal #submit-with-modal').click(function () {
    let url = $(this).closest('#print-worklist-modal').attr('data-url');
    let type = $('#worklist_type').val();

    let original_btn = $('a.print-worklist[data-href="' + url + '"]').get(0);

    url = url.slice(0, -4)

    if(type == 'XLS'){
        url = url.replace('/pdf','/xls')
    }

    if($("input[name='worklist-full']:checked").val() == 1){
        url = url + '/remaining';
    }

    url = url + '/' + $("select[name='worklist_sort']").val();
    url = url + '/' + $("input[name='worklist_safeguard']:checked").val();

    if($("input[name='worklist-comments']:checked").val() == 1){
        url = url + '/1';
    }
    // window.open(url, '_blank');
    generatePdf(original_btn, url);
    $(this).closest('#print-worklist-modal').modal('hide');
});

$('#print-medman-worklist-modal #medman-submit-with-modal').click(function () {
    let url = $(this).closest('#print-medman-worklist-modal').attr('data-url');
    let type = $('#medman_worklist_type').val();

    let original_btn = $('a.print-medman-worklist[data-href="' + url + '"]').get(0);

    url = url.slice(0, -4)

    if(type == 'XLS'){
        url = url.replace('/pdf','/xls')
    }

    if($("input[name='medman-worklist-full']:checked").val() == 1){
        url = url + '/remaining';
    }

    url = url + '/' + $("select#medman_worklist_sort").val();
    url = url + '/1';

    if($("input[name='medman-worklist-comments']:checked").val() == 1){
        url = url + '/1';
    }
    // window.open(url, '_blank');
    generatePdf(original_btn, url);
    $(this).closest('#print-medman-worklist-modal').modal('hide');
});

$('#print-assessment-modal #submit-with-modal').click(function () {
    let url = $(this).closest('#print-assessment-modal').attr('data-url');
    let original_btn = $('a.print-assessment[data-href="' + url + '"]').get(0);

    url = url + '/' + $("select[name='assessment_sort']").val();
    let type = $('#assessment_type').val();

    if(type == 'XLS'){
        url = url.replace('/pdf','/xls')
    }
    if($("input[name='assessment-comments']:checked").val() == 1){
        url = url + '/1';
    }

    generatePdf(original_btn, url);
    $(this).closest('#print-assessment-modal').modal('hide');
});


function updatePlanForm(){
    // MSD-955: this selector was UNSCOPED - it counted every checked
    // .form-control anywhere on the page, not just the ones inside the plan
    // form, so unrelated checkboxes could enable checkout (and the disabled
    // "coming soon" inputs added by MSD-955 sit in the same class).
    const form = document.getElementById('plan_form');
    if (!form) return;
    // form.elements includes staff selections associated from the staff tab.
    const selected = Array.prototype.some.call(form.elements, input => input.matches('.form-control:checked:not(:disabled)'));
    $('#plan_form button, button[form="plan_form"]').attr('disabled', !selected);
}

function updateMedManForm(){
    $('.section_wrap').show();
    $('#medman_form input.form-control:checked').each(function(){
        if($(this).attr('name') == 'bundle[]'){
            let sections = $(this).data('sections').split(',');
            for (index = 0; index < sections.length; index++) {
                $('#section_wrap_'+sections[index]).hide()
            }
        }
    });

    if($(".section_wrap:visible").length){
        $("#sectionsAllTaken").hide();
    }else{
        $("#sectionsAllTaken").show(500);
    }
    $('#medman_form .plan-submit').attr('disabled', $('#medman_form input.form-control:checked').length == 0);
}

function generatePdf(linkref, href){
    // The PDF endpoints STREAM the file (Symfony download response with
    // Content-Disposition), they do NOT return a URL. The old AJAX-then-
    // window.open(data) approach opened the binary PDF body as a URL, so nothing
    // ever downloaded. Trigger the download directly off the constructed URL in
    // this user-gesture handler instead (the server streams the file), which the
    // browser downloads/opens reliably with no popup block.
    let $ref = $(linkref);
    let html = $ref.length ? $ref.html() : '';
    let filename = $ref.attr && $ref.attr('data-filename');

    if ($ref.length) {
        $ref.removeClass('generating-pdf-error').addClass('generating-pdf')
            .attr('disabled', 'disabled')
            .html('Generating <i class="fas fa-spinner fa-spin"></i>');
    }

    try {
        // The endpoint streams the PDF with Content-Disposition: attachment, so a
        // plain same-tab anchor click downloads it in place. Do NOT use
        // target=_blank — that opens a popup (blocked, and not seen as a download
        // by browsers/automation), which is why "no download" was reported.
        var a = document.createElement('a');
        a.href = href;
        a.setAttribute('download', filename || '');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (e) {
        window.location.href = href;
    }

    // The browser handles the streamed download from here; reset the button.
    if ($ref.length) {
        setTimeout(function () {
            $ref.removeAttr('disabled').removeClass('generating-pdf').attr('href', href).html(html);
        }, 1500);
    }
}

$(function() {

    $('.print-worklist').show();
    $('.print-medman-worklist').show();
    $('.print-assessment').show();
    $('.pdf_gen').show();
    $('.pdf_gen').click(function(e){
        e.preventDefault();
        generatePdf(this, $(this).data('href'))
    });


    $('#plan_form button').attr("disabled",true);

    updatePlanForm();

    $('#plan_form').change(function() {
        updatePlanForm();
    });
    updateMedManForm();

    $('#medman_form').change(function() {
        updateMedManForm();
    });

    $("input[name='card']").change(function(){
        updateCardList();
    });
    // MSD-985: a saved card is now preselected on load, so #card-info has to be
    // reconciled immediately. Waiting for a change event that may never fire left
    // the new-card form showing underneath an already-selected saved card.
    updateCardList();
    $(".is-demo").click(function(e){
        e.preventDefault();
        let demo = 1;
        if($(this).hasClass('locked')){
            demo = 0;
        }
        $.post('/toggle-demo', {'demo' : demo, '_token' : $(this).data('token')},
            function (data, status) {
                location.reload();
            }
        );
    });

});

function updateCardList(){
    // MSD-985: when the company has no saved cards there is no radio group at all
    // and #card-info is the only payment input on the page, rendered visible by the
    // blade's @else branch. Calling this on load (which we now do) would otherwise
    // hide the one form the buyer needs.
    if($("input[name='card']").length === 0){
        $('#card-info').show();
        return;
    }
    if($("input[name='card']:checked").val() == '0'){
        $('#card-info').show();
    }else{

        $('#card-info').hide();
    }
}
